export default "/v8.53.0/1986b3c/bundles/opensearch.xml";